export default __webpack_public_path__ + "static/media/ic_degen.69153ab5.svg";